var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "v-application font-size-14"
  }, [_c('div', {
    staticClass: "w-100 px-2 py-4"
  }, [_vm._m(0), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('div', [_c('div', {
    staticClass: "font-size-16 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.getToday))]), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "placeholder": "상호"
    },
    model: {
      value: _vm.userName,
      callback: function callback($$v) {
        _vm.userName = $$v;
      },
      expression: "userName"
    }
  }), _c('span', [_vm._v(" 귀하")])], 1), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("아래와 같이 명세합니다.")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('table', {
    staticClass: "table--border w-100"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "2%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "33%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "14%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "34%"
    }
  })]), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("공"), _c('br'), _vm._v("급"), _c('br'), _vm._v("자")]), _c('td', {
    staticClass: "font-weight-medium"
  }, [_vm._v("등록번호")]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("846-81-00822")])]), _c('tr', [_c('td', {
    staticClass: "font-weight-medium"
  }, [_vm._v("상호")]), _c('td', [_vm._v("주식회사 대한문고")]), _c('td', {
    staticClass: "font-weight-medium"
  }, [_vm._v("성명")]), _c('td', [_vm._v("우상덕")])]), _c('tr', [_c('td', {
    staticClass: "font-weight-medium"
  }, [_vm._v("사업장"), _c('br', {
    staticClass: "d-none d-sm-block"
  }), _vm._v("주소")]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("서울 강서구 공항대로228, 리더스타워 704, 705호")])]), _c('tr', [_c('td', {
    staticClass: "font-weight-medium"
  }, [_vm._v("업태")]), _c('td', [_vm._v("도소매")]), _c('td', {
    staticClass: "font-weight-medium"
  }, [_vm._v("종목")]), _c('td', [_vm._v("도서 . 문구")])]), _c('tr', [_c('td', {
    staticClass: "font-weight-medium"
  }, [_vm._v("전화번호")]), _c('td', [_vm._v("1800-9510")]), _c('td', {
    staticClass: "font-weight-medium"
  }, [_vm._v("FAX")]), _c('td', [_vm._v("02-6442-9520")])])])])])], 1), _c('v-divider', {
    staticClass: "my-4",
    staticStyle: {
      "border-color": "#ccc!important"
    }
  }), _c('div', {
    staticClass: "mb-3"
  }, [_c('strong', {
    staticClass: "font-size-18"
  }, [_vm._v("￦ " + _vm._s(_vm.totalPrice.format()))]), _c('span', {
    staticClass: "font-size-14"
  }, [_vm._v(" (VAT 포함)")])]), _c('table', {
    staticClass: "table--border w-100"
  }, [_vm._m(1), _c('tbody', [_vm._m(2), _vm._l(_vm.purchases, function (purchase, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _c('td', [_vm._v(_vm._s(purchase.product.name))]), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(purchase.quantity))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(purchase.product.salePrice.format()) + "원")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s((purchase.product.salePrice * purchase.quantity).format()) + "원")])]);
  }), _c('tr', [_c('th', [_vm._v("계")]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.totalPrice.format()) + "원")])])], 2)]), _c('div', {
    staticClass: "text-center mt-5 d-print-none"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.print
    }
  }, [_vm._v("출력")])], 1)], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center mb-5"
  }, [_c('h1', {
    staticClass: "font-size-26",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("도서거래 명세서")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "5%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "49%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "18%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "18%"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('th', [_vm._v("No")]), _c('th', [_vm._v("품목")]), _c('th', [_vm._v("수량")]), _c('th', [_vm._v("단가"), _c('br'), _vm._v("(VAT 포함)")]), _c('th', [_vm._v("합계")])]);
}]

export { render, staticRenderFns }